import { render, staticRenderFns } from "./bank-list.vue?vue&type=template&id=96db1668&scoped=true&"
import script from "./bank-list.vue?vue&type=script&lang=js&"
export * from "./bank-list.vue?vue&type=script&lang=js&"
import style0 from "./bank-list.vue?vue&type=style&index=0&id=96db1668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96db1668",
  null
  
)

export default component.exports